var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "black",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7565 12.6488C15.7565 14.5711 14.2177 16.1151 12.337 16.1151C10.4563 16.1151 8.91748 14.5711 8.91748 12.6488C8.91748 10.7266 10.4563 9.18262 12.337 9.18262C14.2177 9.18262 15.7565 10.7266 15.7565 12.6488Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4491 17.4673C17.7791 17.7176 18.2467 17.6508 18.4935 17.3181C18.7402 16.9855 18.6727 16.5128 18.3427 16.2626L17.4491 17.4673ZM14.6694 15.3592L17.4491 17.4673L18.3427 16.2626L15.563 14.1544L14.6694 15.3592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchButton);
export default __webpack_public_path__ + "static/media/icon-search-button.773844a042cd30dd32362022f3434144.svg";
export { ForwardRef as ReactComponent };